import React, { FC, ReactNode } from 'react';

import { StyleSheet, View } from 'react-native';

import { StartOrderEmptyState } from './start-order-empty-state';
import { Wrap } from './styled';

interface IOrdersEmptyProps {
  children?: ReactNode;
}

const OrdersEmpty: FC<React.PropsWithChildren<IOrdersEmptyProps>> = ({ children }) => {
  return (
    <View style={styles.wrapper}>
      <Wrap>
        <StartOrderEmptyState />
      </Wrap>
      {children}
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    flexGrow: 1,
  },
});

export default OrdersEmpty;
